<template>
  <div class="imgVideoCenter">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="imgVideo" style="position: relative">
        <template #title>
          <span>
            <img src="../../assets/svg/imgVideo.svg" alt="" />
            <!-- <i class="el-icon-arrow-right"></i> -->
            图片和视频
          </span>
          <span
            class="lineTheme"
            @click.prevent.stop="downloadAllFiles()"
            style="position: absolute; left: 130px"
            >一键下载附件</span
          >
        </template>
        <div class="uploadTips" v-if="!authStatus">
          <fileUploadTips></fileUploadTips>
        </div>
        <div>
          <el-form
            ref="imgVideoForm"
            :model="form"
            :rules="formRules"
            label-width="165px"
          >
            <!-- 是否有故障视频/图片 -->
            <el-form-item label="是否有故障视频/图片" prop="faultVideo">
              <el-radio-group
                v-model="form.faultVideo"
                @change="inputChange(form.faultVideo, 'faultVideo')"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :label="getLabelName(form.faultVideoFiles)"
              prop="faultVideoFiles"
              v-if="form.faultVideo == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="form.faultVideoFiles"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="form.faultVideoFiles"
                :tipStatus="false"
                :disabled="authStatus"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=19"
              />
            </el-form-item>
            <!-- 是否有故障代码 -->
            <el-form-item label="是否有故障代码" prop="faultCode">
              <el-radio-group
                v-model="form.faultCode"
                @change="inputChange(form.faultCode, 'faultCode')"
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="备注"
              prop="faultCodeRemark"
              v-if="form.faultCode == 1"
            >
              <el-input
                v-if="!authStatus"
                v-model="form.faultCodeRemark"
                @blur="inputBlur(form.faultCodeRemark, 'faultCodeRemark')"
                placeholder="请输入备注"
                :disabled="authStatus"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 2 }"
                maxlength="500"
                show-word-limit
              ></el-input>
              <div v-else class="problemDesInfo">{{ form.faultCodeRemark }}</div>
            </el-form-item>
            <el-form-item
              :label="getLabelName(form.faultCodeFiles)"
              prop="faultCodeFiles"
              v-if="form.faultCode == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="form.faultCodeFiles"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="form.faultCodeFiles"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=20"
              />
            </el-form-item>
            <!-- 是否有其他说明 -->
            <el-form-item label="是否有其他说明" prop="otherInstructions">
              <el-radio-group
                v-model="form.otherInstructions"
                @change="
                  inputChange(form.otherInstructions, 'otherInstructions')
                "
                :disabled="authStatus"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="备注"
              prop="otherRemark"
              v-if="form.otherInstructions == 1"
            >
              <el-input
                v-if="!authStatus"
                v-model="form.otherRemark"
                @blur="inputBlur(form.otherRemark, 'otherRemark')"
                :disabled="authStatus"
                placeholder="请输入备注"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 2 }"
                maxlength="500"
                show-word-limit
              ></el-input>
              <div v-else class="problemDesInfo">{{ form.otherRemark }}</div>
            </el-form-item>
            <el-form-item
              :label="getLabelName(form.otherFiles)"
              prop="otherFiles"
              v-if="form.otherInstructions == 1"
            >
              <file-upload-list
                v-if="authStatus"
                ref="fileUploadList"
                :fileList="form.otherFiles"
              ></file-upload-list>
              <drag-upload
                ref="uploadFile"
                v-else
                :accessoryList.sync="form.otherFiles"
                :tipStatus="false"
                httpRequest="/manage/car/feedback/question/upload/file?fileType=21"
              />
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import JSZip from "jszip";
import FileSaver from "file-saver";
import fileUploadTips from "@/components/fileUpload/fileUploadTips.vue";
export default {
  name: "imgVideo",
  components: { fileUploadTips },
  data() {
    return {
      activeNames: ["imgVideo"], // 全部展开
      form: {},
      allFileList: [],
    };
  },
  props: {
    resourceInfo: {
      type: [Array, Object],
    },
    authStatus: {
      type: Boolean,
    },
  },
  async created() {
    this.getResourceInfo();
  },
  // 上传文件保存数据
  watch: {
    "form.faultVideoFiles"(newVal, oldVal) {
      if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
        this.resourceInfo.faultVideoFiles = newVal;
        this.$emit("update:resourceInfo", this.resourceInfo);
      }
    },
    "form.faultCodeFiles"(newVal, oldVal) {
      if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
        this.resourceInfo.faultCodeFiles = newVal;
        this.$emit("update:resourceInfo", this.resourceInfo);
      }
    },
    "form.otherFiles"(newVal, oldVal) {
      if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
        this.resourceInfo.otherFiles = newVal;
        this.$emit("update:resourceInfo", this.resourceInfo);
      }
    },
  },
  computed: {
    // 必填校验
    formRules() {
      const isRequired = !this.authStatus;
      // 公共规则配置
      const commonRule = {
        required: isRequired,
        trigger: ["change", "blur"],
      };
      // 文件类字段的通用规则
      const createRule = (fieldName) => [
        { ...commonRule, message: `${fieldName}不能为空` },
      ];
      return {
        faultVideo: createRule("是否有故障视频/图片"),
        faultVideoFiles: createRule("是否有故障视频/图片附件"),
        faultCode: createRule("是否有故障代码"),
        faultCodeRemark: createRule("是否有故障代码备注"),
        otherInstructions: createRule("是否有其他说明"),
        otherRemark: createRule("是否有其他说明备注"),
      };
    },
  },
  methods: {
    // 获取数据
    getResourceInfo() {
      if (this.resourceInfo) {
        this.form = this.resourceInfo;
        this.form.faultVideoFiles = this.convertArrayData(
          this.resourceInfo.faultVideoFiles
        );
        this.form.faultCodeFiles = this.convertArrayData(
          this.resourceInfo.faultCodeFiles
        );
        this.form.otherFiles = this.convertArrayData(
          this.resourceInfo.otherFiles
        );
        this.allFileList = [
          ...this.form.faultVideoFiles,
          ...this.form.faultCodeFiles,
          ...this.form.otherFiles,
        ];
      }
    },
    // 监听是否状态切换
    inputChange(val, type) {
      this.form[type] = val;
      this.$emit("update:resourceInfo", this.form);
    },
    // 监听失去焦点
    inputBlur(val, type) {
      this.form[type] = val;
      this.$emit("update:resourceInfo", this.form);
    },
    // 附件标题是否显示
    getLabelName(file) {
      if (this.authStatus) {
        if (file.length > 0) {
          return "附件";
        } else {
          return "";
        }
      } else {
        return "附件";
      }
    },
    validateForm() {
      return this.$refs["imgVideoForm"]
        .validate()
        .then(() => ({ isValid: true, object: null }))
        .catch((errors) => ({ isValid: false, object: errors }));
    },
    // 一键下载附件
    async downloadAllFiles() {
      try {
        const files = this.allFileList || [];

        if (files.length === 0) {
          this.$DonMessage.warning("暂无附件");
          return;
        }

        const zip = new JSZip();
        const fileCountMap = {}; // 用于记录同名文件出现次数

        await Promise.all(
          files.map(async (item, index) => {
            try {
              const url = item.url || item.filePath;
              if (!url) return;

              const response = await fetch(url);
              if (!response.ok) throw new Error(`下载失败：${url}`);

              const blob = await response.blob();
              let fileName = item.fileName || item.name || `附件_${index + 1}`;

              // 处理同名文件
              if (zip.files[fileName]) {
                fileCountMap[fileName] = (fileCountMap[fileName] || 0) + 1;
                const ext = fileName.split(".").pop();
                const baseName = fileName.replace(/\.[^/.]+$/, "");
                fileName = `${baseName}_${fileCountMap[fileName]}.${ext}`;
              }
              zip.file(fileName, blob);
            } catch (error) {
              console.error(`文件下载失败: ${error.message}`);
              throw error;
            }
          })
        );

        const zipBlob = await zip.generateAsync({
          type: "blob",
          compression: "DEFLATE",
        });

        saveAs(zipBlob, `图片和视频附件_${new Date().getTime()}.zip`);
        this.$DonMessage.success("下载完成");
      } catch (error) {
        console.error("打包下载失败:", error);
        this.$DonMessage.error(`下载失败: ${error.message}`);
      }
    },
  },
};
</script>
